export default __webpack_public_path__ + "static/media/icon_radio_enabled.b0a27f3b.svg";